/**
 * Menu Model
 */

define(function(require, exports, module) {
    'use strict';

    var MenuModel = require('modules/menu/menu.model');
    var _ = require('underscore');
    var utils = require('utils');
    var urlUtil = require('util/url.util');
    var config = require('config');
    var device = require('util/device.util');

    module.exports = MenuModel.extend({

        getInitialClonedItems: function() {
            const twoLetterLanguage = Playtech.API.language.getTwoLetterCurrentLanguage();

            const updateFriendlyUrl = function(item) {
                if (urlUtil.getCleanUrl(item.url) === '/') {
                    item.friendlyURL = '/';
                }
            };

            // ~(Lugano MWL-13945)~
            const updateHomeUrl = function(item) {
                const rootPage = urlUtil.getCleanUrl(config.get('rootPage'));

                if (urlUtil.getCleanUrl(item.url) === rootPage) {
                    item.friendlyURL = `/${twoLetterLanguage}/`;
                    item.url = `/${twoLetterLanguage}/`;
                }
            };

            const markMenuItemAsOpener = function(item) {
                const chatConfig = config.get('chatWidget');
                const inboxConfig = config.get('inboxWidget');

                if (inboxConfig && inboxConfig.enabled && inboxConfig.counterPage === item.url) {
                    item.inboxOpener = true;
                }

                if (chatConfig && chatConfig.enabled && chatConfig.counterPage === item.url) {
                    item.chatOpener = true;
                }
            };

            return utils.deepClone(config.get('menuItems')[0]?.children || [])
                ?.map(function(item) {
                    updateFriendlyUrl(item);
                    // ~(Lugano MWL-13945)~
                    updateHomeUrl(item);

                    markMenuItemAsOpener(item);

                    if (item.children) {
                        item.children.forEach(function(child) {
                            // For case when item has the same link as one of children
                            updateFriendlyUrl(child);

                            // Find and mark inbox opener among children
                            markMenuItemAsOpener(child);
                        });

                        const activeMenu = item.children.some((page) => {
                            return urlUtil.getCleanUrl(page.friendlyURL) === urlUtil.getCleanUrl(urlUtil.pathname); // Lugano changes }}
                        });

                        if (device.formFactor === 'desktop') {
                            item.expandable = Boolean(item.cssClasses.includes('desktop-expandable'));
                            item.expandedByDefault = Boolean(item.cssClasses.includes('show-expanded')) || activeMenu && item.expandable;
                        } else if (device.formFactor === 'tablet') {
                            item.expandable = Boolean(item.expandablePageTablet);
                            item.expandedByDefault = Boolean(item.expandedByDefaultTablet) || activeMenu && item.expandable;
                        } else if (device.formFactor === 'mobile') {
                            item.expandable = Boolean(item.expandablePageMobile);
                            item.expandedByDefault = Boolean(item.expandedByDefaultMobile) || activeMenu && item.expandable;
                        }
                    }

                    return item;
                }) ?? [];
        },

        /**
         * Get current menu item for current URL
         * @param  {string} friendlyURL
         * @param isMenuItems
         * @return {Object} Child item menu
         */
        getCurrentItem: function(friendlyURL, isMenuItems = false) {
            const twoLetterLanguage = Playtech.API.language.getTwoLetterCurrentLanguage();
            const sportsbookRootURL = this.getSportsbookRootURL();

            function find(items, path) {
                // Lugano changes }}
                return utils.deepFind(items, 'children', 'friendlyURL', isMenuItems ? `/${twoLetterLanguage}${path}` : path);
            }

            let filteredItems = this._findAmongFilteredItems(find, friendlyURL);

            if (_.isEmpty(filteredItems) && this.isSportPage(urlUtil.pathname)) {
                filteredItems = this._findAmongFilteredItems(find, sportsbookRootURL);
            }

            return filteredItems;
        },

        /**
         * Get URL of current page
         * @param  {string} friendlyURL
         * @return {string} Current page URL
         */
        getCurrentPageURL: function(friendlyURL) {
            const twoLetterLanguage = Playtech.API.language.getTwoLetterCurrentLanguage();
            const pageUrl = friendlyURL !== undefined ? friendlyURL : urlUtil.pathname;
            const rootPageUrl = `/${twoLetterLanguage}/`;

            if (!pageUrl || urlUtil.getCleanUrl(pageUrl) === rootPageUrl) {
                return rootPageUrl; /* Lugano changes */
            }

            return urlUtil.getCleanUrl(this._handleLeaderBoardPage(pageUrl));
        },

        /**
         * Get siblings menu items for current URL
         * @param  {string} friendlyURL
         * @return {Array} List of items
         */
        getCurrentSiblings: function(friendlyURL) {
            function find(items, source) {
                var result;
                var item;

                for (var i = 0, len = items.length; i < len; i++) {
                    item = items[i];

                    if (item.friendlyURL === source) {
                        return items;
                    } else if (item.children) {
                        result = item.children;
                    }

                    if (result) {
                        return result;
                    }
                }
            }

            return this._findAmongFilteredItems(find, friendlyURL);
        }
    });
});
